import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useAppSelector } from "../store";

export interface SettingsState {
  walletHideLowBalances: boolean;
  selectedCurrency: string;
  loginEmail: string;
  isMultiAccountApplication: boolean;
  numberOfAccounts: number;
  expandedMenuItem: string[];
}

const initialState: SettingsState = {
  walletHideLowBalances: false,
  selectedCurrency: "AUD",
  loginEmail: "",
  isMultiAccountApplication: false,
  numberOfAccounts: 1,
  expandedMenuItem: [""],
};

const SettingsSlice = createSlice({
  name: "settings",
  initialState: initialState,
  reducers: {
    setWalletHideLowBalances: (state: SettingsState, action: PayloadAction<boolean>): void => {
      state.walletHideLowBalances = action.payload;
    },
    setSelectedCurrency: (state: SettingsState, action: PayloadAction<string>): void => {
      state.selectedCurrency = action.payload;
    },
    setLoginEmail: (state: SettingsState, action: PayloadAction<string>) => {
      state.loginEmail = action.payload;
      state.isMultiAccountApplication = false;
    },
    setIsMultiAccountApplication: (state: SettingsState, action: PayloadAction<boolean>): void => {
      state.isMultiAccountApplication = action.payload;
    },
    setNumberOfAccounts: (state: SettingsState, action: PayloadAction<number>): void => {
      state.numberOfAccounts = action.payload;
    },
    setExpandedMenuItem: (state: SettingsState, action: PayloadAction<string>): void => {
      if (!state.expandedMenuItem) {
        state.expandedMenuItem = [""];
      }
      if (state.expandedMenuItem?.includes(action.payload)) {
        // if the menu item exists in array, remove it
        state.expandedMenuItem = state.expandedMenuItem.filter((el) => el !== action.payload);
      } else {
        // Add the element if it doesn't exist
        state.expandedMenuItem?.push(action.payload);
      }
    },
  },
});

export const {
  setWalletHideLowBalances,
  setSelectedCurrency,
  setLoginEmail,
  setIsMultiAccountApplication,
  setNumberOfAccounts,
  setExpandedMenuItem,
} = SettingsSlice.actions;

export const useSettingsState = () => useAppSelector((state) => state.settings);

export default SettingsSlice;
